<template>
  <div class="filter-block__group">
    <div class="filter-block__text">
      {{ $t("Price") }}
    </div>
    <vue-slider
      id="slider-range"
      ref="slider"
      v-model="sliderVal"
      class="ui-slider"
      style="padding: 0"
      :lazy="true"
      :dot-size="18"
      :height="3"
      :process-style="{
        backgroundColor: '#f95c4e',
      }"
      tooltip-class="sliderTooltip"
      :min="field.min"
      :max="field.max"
    />
    <div slot="field" class="form-row">
      <div class="col">
        <input v-model="fieldValue.gte" type="number" class="form-control" />
      </div>
      <div class="col">
        <input v-model="fieldValue.lte" type="number" class="form-control" />
      </div>
    </div>
  </div>
</template>

<script>
import { FieldMixin } from "stylemix-base";
import vueSlider from "vue-slider-component";

export default {
  name: "FormSliderField",

  components: {
    vueSlider,
  },

  mixins: [FieldMixin],

  data: () => ({}),

  computed: {
    sliderVal: {
      set(value) {
        this.fieldValue.gte = value[0] || this.field.min;
        this.fieldValue.lte = value[1] || this.field.max;
      },
      get() {
        return [this.fieldValue.gte, this.fieldValue.lte];
      },
    },
  },

  created() {
    if (!this.fieldValue) {
      this.fieldValue = {
        gte: null,
        lte: null,
      };
    }
  },
};
</script>
